import { css, cx } from "@emotion/css";
type YouTubePlayerProps = {
    videoId: string;
};
export function YouTubePlayer({ videoId }: YouTubePlayerProps) {
    return (<iframe className={cx(style)} src={`https://www.youtube.com/embed/${videoId}?rel=0`} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox" referrerPolicy="strict-origin-when-cross-origin"></iframe>);
}
const style = css({
    width: "100%",
    aspectRatio: "16 / 9",
});
